// Generated by CoffeeScript 2.4.1
(function() {
  var ErrorCodes, GET, Promise, Weaver, WeaverDomain, WeaverError, WeaverRole;

  WeaverRole = require('./WeaverRole');

  Weaver = require('./Weaver');

  GET = Weaver.GET;

  Promise = require('bluebird');

  WeaverError = require('./Error');

  ErrorCodes = require('./WeaverError');

  WeaverDomain = class WeaverDomain extends WeaverRole {
    constructor(name, active = true) {
      super(name);
      this.active = active;
      this._isDomain = true;
    }

    listUsers() {
      return super.getUsers();
    }

    async listProjects() {
      return (await GET('domain.listProjects', {
        id: this.id()
      }));
    }

    destroy() {
      throw WeaverError(ErrorCodes.OTHER_CAUSE, 'Not possible to delete Domains');
    }

    activate() {
      return this.active = true;
    }

    deactivate() {
      return this.active = false;
    }

    isActive() {
      return this.active;
    }

    static async list() {
      var i, len, r, results, roles;
      roles = (await GET("domains"));
      results = [];
      for (i = 0, len = roles.length; i < len; i++) {
        r = roles[i];
        results.push(WeaverDomain.loadFromServerObject(r));
      }
      return results;
    }

    static loadFromServerObject(domainObject) {
      var i, j, len, len1, ref, ref1, role, u;
      role = new WeaverDomain(domainObject.name, domainObject.active);
      // Copy
      role._id = domainObject.roleId;
      role._name = domainObject.name;
      role._stored = true;
      ref = domainObject.users;
      for (i = 0, len = ref.length; i < len; i++) {
        u = ref[i];
        role._usersMap[u] = true;
      }
      ref1 = domainObject.roles;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        u = ref1[j];
        role._rolesMap[u] = true;
      }
      role.active = domainObject.active;
      return role;
    }

  };

  module.exports = WeaverDomain;

}).call(this);
